// extracted by mini-css-extract-plugin
var _1 = "jkptIZzaLsnZtZNf7Iu7";
var _2 = "XTtTw8qsqJuKE1gj1p5A";
var _3 = "kzDyGEDmgulDkbT0C_uX";
var _4 = "bswhiLRaw_m5QTDJy4ns";
var _5 = "TzQfSymfMfufqdL0FwiW";
var _6 = "M4avoYpcqaKTkJMWW0Hf";
var _7 = "cRNkxCJOEtq8QDOCOOpp";
var _8 = "bfOwNCIJkVKkUgGqj1PD";
export { _1 as "btn-close--modal-media", _2 as "close-btn", _3 as "container", _4 as "icon", _5 as "icons", _6 as "modal-body", _7 as "modal__btn-next", _8 as "modal__btn-prev" }
